import { render, staticRenderFns } from "./EditPriceDialog.vue?vue&type=template&id=5408e168&scoped=true"
import script from "./EditPriceDialog.vue?vue&type=script&lang=js"
export * from "./EditPriceDialog.vue?vue&type=script&lang=js"
import style0 from "./EditPriceDialog.vue?vue&type=style&index=0&id=5408e168&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5408e168",
  null
  
)

export default component.exports